export enum ConnectorStatus {
    AVAILABLE = 'Available',
    PREPARING = 'Preparing',
    CHARGING = 'Charging',
    FINISH = 'Finishing',
    SUSPENDEDEV = 'SuspendedEV',
    FAULTED = 'Faulted',
    SUSPENDEDEVSE = 'SuspendedEVSE',
    UNAVAILABLE = 'Indisponível'
}